var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHrIcon = function SvgHrIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none",
    viewBox: "0 0 73 73"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M54.893 2A16.021 16.021 0 0 0 42.82 28.643l-2.015 11.59 10.496-6.473A16.086 16.086 0 1 0 54.892 2M20.398 50.293c5.715 0 10.348-4.633 10.348-10.348s-4.633-10.349-10.348-10.349-10.349 4.633-10.349 10.349c0 5.715 4.633 10.348 10.349 10.348M38.795 70.99A18.563 18.563 0 0 0 2 70.99"
  })));
};
export default SvgHrIcon;